import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getFollowing, updateFollow, Follower } from '@happenings/components/entities/follows';
import Store from '@happenings/components/store';

interface ListElement {
  username: string;
  display_name: string;
}

interface UserListProps {
  list: ListElement[];
}

const UserList: React.FC<UserListProps> = ({ list }) => {
  const currentUsername = useSelector((state: Store) => state.session.currentUser?.username);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (currentUsername) {
      dispatch(getFollowing(currentUsername));
    }
  }, [currentUsername]);

  const following = useSelector((state: Store) => {
    const followMap: Record<string, { awaitingApproval: boolean }> = {};
    if (currentUsername) {
      state.entities.follows[currentUsername]?.following.forEach((follower: Follower) => {
        followMap[follower.username] = {
          awaitingApproval: follower.awaiting_approval,
        };
      });
    }
    return followMap;
  });

  const updatedList = list.map((user) => ({
    ...user,
    following: !!following[user.username],
    awaitingApproval: following[user.username]?.awaitingApproval || false,
  }));

  return (
    <div>
      {updatedList.map((user) => (
        <div key={user.username} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Link to={`/user/${user.username}`}>
            {user.display_name || user.username}
          </Link>
          {user.username !== currentUsername && (
            <button
              onClick={() => dispatch(updateFollow(user.username, !user.following))}
              disabled={user.awaitingApproval}
            >
              {user.awaitingApproval ? 'Pending' : user.following ? 'Following' : 'Follow'}
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default UserList;